module.exports = __webpack_public_path__ + "img/跳绳视频.d9bbd018.png";